import type { roomPrepareCheckInterface } from '@/types/apiType/liveType'

import {
  apiRoomPrepareCheck,
  apiRoomFrontCheck,
  apiRoomVideoChannelList
} from '@/api/live'
export const useHostLiveStore = defineStore({
  id: 'hostLive',
  state: () => ({
    /** 房间开播前置检查信息,没通过就不给直播 */
    roomPrepareCheckConfig: {} as roomPrepareCheckInterface,
    /** 开播信息配置 */
    roomFrontCheckForm: {
      startLiveTitle: '', // 房间标题
      autoIdal: true, // 自动接听,
      avatar: '' // App试使用，主播开播要传的封面
    } as { startLiveTitle: string; autoIdal: boolean; avatar: string },
    /** 是否判断验证是否可开播成功过*/
    isRoomFrontCheckSuccess: false as boolean
  }),
  actions: {
    /** 设置开播信息 */
    setRoomFrontCheckForm(title, avatar) {
      this.roomFrontCheckForm.startLiveTitle = title
      this.roomFrontCheckForm.avatar = avatar
    },
    /** 判断验证是否可开播 */
    async roomFrontCheck(roomType: 3 | 6) {
      const router = useRouter()
      const i18n = useNuxtApp().$i18n
      const userStore = useUserStore()
      const publicStore = usePublicStore()
      const runtimeConfig = useRuntimeConfig()
      const roomStore = useRoomStore()

      // 在APP就不做是否可开播了判断，直接给过
      if (roomStore.isApp) {
        this.isRoomFrontCheckSuccess = true
        return Promise.reject(true)
      }

      // 有IOSUDID并且是女性才可以正常走流程
      // APP不判断udid
      if (
        !roomStore.isApp &&
        !publicStore.iosUDID &&
        userStore.userInfo.gender !== 2 &&
        (common.checkVersion().safari ||
          runtimeConfig.public.appMode !== 'production')
      ) {
        showToast(i18n.t('live.PleaseGetUDID'))
        this.isRoomFrontCheckSuccess = false
        return Promise.reject(false)
      }

      if (roomStore.roomType === constant.ROOM_TYPE.AUDIO_LIVE) {
        // 如果是语音直播，判断是否需要更换头像
        if (!this.roomPrepareCheckConfig.voiceCheck) {
          showToast(i18n.t('live.PleaseReselectTheUploadCover'))
          return Promise.reject(false)
        }
      } else {
        // 如果是视频直播，就判断是否需要人脸认证
        if (!this.roomPrepareCheckConfig.liveCheck) {
          showConfirmDialog({
            message: i18n.t('live.verifyTips'),
            confirmButtonText: i18n.t('public.Yes'),
            cancelButtonText: i18n.t('public.No'),
            className: 'private-dialog-customize'
          }).then(() => {
            const runtimeConfig = useRuntimeConfig()
            // 是否重定向，不在APP内，当前域名要和 cdnUrl 一样才可以重定向
            if (
              !roomStore.isApp &&
              (location.origin === runtimeConfig.public.cdnUrl ||
                runtimeConfig.public.appMode === 'development')
            ) {
              router.push('/verify')
            }
          })
          this.isRoomFrontCheckSuccess = false
          return Promise.reject(false)
        }
      }
      // 如果未填写标题
      if (!this.roomFrontCheckForm.startLiveTitle) {
        showToast(i18n.t('live.PleaseModifytheRoomTitle'))
        this.isRoomFrontCheckSuccess = false
        return Promise.reject(false)
      }
      // 如果未填写标题
      const roomInfoConfig = this.roomPrepareCheckConfig.roomInfo.find(
        (v) => v.roomType === roomStore.roomType
      )
      if (!roomInfoConfig || roomInfoConfig.reset) {
        showToast(i18n.t('live.PleaseReselectTheUploadCover'))
        this.isRoomFrontCheckSuccess = false
        return Promise.reject(false)
      }

      // 传参判断是否可开播
      const res = await apiRoomFrontCheck({
        roomType: roomType,
        avatar: roomInfoConfig.coverUrl,
        title: this.roomFrontCheckForm.startLiveTitle,
        autoIdal: this.roomFrontCheckForm.autoIdal
      })
      if (res.code === 200) {
        this.isRoomFrontCheckSuccess = true
        return Promise.resolve(true)
      }
      this.isRoomFrontCheckSuccess = false
      return Promise.reject(false)
    },
    /**
     * 获取房间开播前置检查信息 roomPrepareCheckConfig
     * @param {boolean} isRefresh 是否强制刷新，默认false
     * */
    async getRoomPrepareCheckConfig(isRefresh: boolean = false) {
      // 有数据&&不是强制刷新 就返回
      if (this.roomPrepareCheckConfig.roomInfo && !isRefresh) {
        return Promise.resolve(
          this.roomPrepareCheckConfig as roomPrepareCheckInterface
        )
      }
      // 没数据就重新获取
      await apiRoomVideoChannelList()
      const res = await apiRoomPrepareCheck()
      if (res.code === 200) {
        this.roomPrepareCheckConfig = res.data
        return Promise.resolve(
          this.roomPrepareCheckConfig as roomPrepareCheckInterface
        )
      }
      return Promise.reject(false)
    }
  },
  persist: {
    key: 'hostLiveStore',
    paths: ['roomFrontCheckForm']
  }
})
